import dayjs from 'dayjs';
import {
  ACI_LOCALE_IMPORT_MAP,
  ACI_LOCALE_MAP,
  DAYJS_LANG_IMPORT_MAP,
  DAYJS_LANG_MAP,
  UIKIT_LOCALE_IMPORT_MAP
} from '@/common/constants/i18n.constants';
import { locale as elementLocale } from '@uikit/ui-kit';
import i18n from '@/common/i18n';

export const applyDayJsLocale = async (locale) => {
  const dayjsLocale = DAYJS_LANG_MAP[locale];
  const dayjsLang = await (
      DAYJS_LANG_IMPORT_MAP[locale]
      || DAYJS_LANG_IMPORT_MAP[ACI_LOCALE_MAP.en])();

  dayjs.locale(dayjsLocale);

  return dayjsLang.default;
};

export const applyUikitLocale = async (locale) => {
  const uikitLocale = await (
      UIKIT_LOCALE_IMPORT_MAP[locale]
      || UIKIT_LOCALE_IMPORT_MAP[ACI_LOCALE_MAP.en])();

  return elementLocale(uikitLocale.default);
};

export const loadLocaleMessages = async (locale) => {
  const messages = await (
      ACI_LOCALE_IMPORT_MAP[locale]
      || ACI_LOCALE_IMPORT_MAP[ACI_LOCALE_MAP.en])();

  i18n.setLocaleMessage(locale, messages.default);
};
